import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Stack, Typography, InputAdornment, Grid } from '@mui/material';
import { InputNumber } from 'app/components/elements/InputNumber';
import { FormPostSeizure } from './modules/FormPostSeizure/FormPostSeizure';
import { InputText } from '../../../../../components/elements/InputText';
import { IconMoney } from '../../../../../../assets/icon';
import dayjs from 'dayjs';
import CustomDatePicker from '../../../../../components/elements/InputDate';

const COST_DETAIL_FIELDS = [
  { name: 'bailiffFees', label: 'Bailiff Fees', type: 'number' },
  { name: 'redemptionFees', label: 'Redemption Fees', type: 'number' },
  { name: 'mvsFees', label: 'MVS Fees', type: 'number' },
  { name: '', label: '' },
  { name: 'arrears', label: 'Arrears', type: 'number' },
  { name: 'arrearsTo', label: 'Arrears To', type: 'number' },
  { name: 'clientFees', label: 'Client Fees', type: 'number' },
  { name: 'otherFeesIncurred', label: 'Other Fees Incurred', type: 'number' },
  { name: 'auctionFees', label: 'Auction Fees', type: 'string' },
  { name: 'transportFees', label: 'Transport Fees', type: 'string' },
  { name: '', label: '' },
  { name: 'otherFees', label: 'Other Fees Amount', type: 'number' }
] as const;

const CostDetailSection: React.FC = () => {
  const {
    watch,
    register,
    control,
    formState: { errors }
  } = useFormContext<FormPostSeizure>();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const costDetailErrors = (errors as any)?.costDetail || {};
  console.log(watch('costDetail'));
  return (
    <Stack gap={2}>
      <Typography style={{ fontSize: 16, fontWeight: 700, marginBottom: 8 }}>
        Cost Details
      </Typography>

      <Grid container spacing={2}>
        {COST_DETAIL_FIELDS.map((field, index) => {
          if (field?.name === 'otherFeesIncurred') {
            return (
              <Grid key={index} item xs={12} sm={3}>
                <InputText
                  title={field.label}
                  placeholder={field.label}
                  inputError={costDetailErrors?.costDetail?.otherFeesIncurred?.message}
                  inputProps={{
                    ...register('costDetail.otherFeesIncurred')
                  }}
                />
              </Grid>
            );
          }
          if (field?.name === 'arrearsTo') {
            return (
              <Grid key={index} item xs={12} sm={3}>
                <Controller
                  name={'costDetail.arrearsTo'}
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <CustomDatePicker
                      inputError={errors?.costDetail?.arrearsTo?.message}
                      title={field.label}
                      value={value ? dayjs(value) : null}
                      onChange={onChange}
                      datePickerProps={{}}
                    />
                  )}
                />
              </Grid>
            );
          }
          return (
            <Grid key={index} item xs={12} sm={3}>
              {field?.name ? (
                <Controller
                  name={`costDetail.${field.name}`}
                  control={control}
                  render={({ field: { onChange, value } }) => {
                    if (field.type === 'string') {
                      return (
                        <InputText
                          title={field.label}
                          placeholder={field.label}
                          inputError={costDetailErrors?.[field.name]?.message}
                          inputProps={{
                            value
                          }}
                          onChange={onChange}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconMoney />
                            </InputAdornment>
                          }
                        />
                      );
                    }
                    return (
                      <InputNumber
                        inputProps={{}}
                        title={field.label}
                        placeholder={field.label}
                        value={Number(value)}
                        onChange={onChange}
                        inputError={costDetailErrors?.[field.name]?.message}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconMoney />
                          </InputAdornment>
                        }
                      />
                    );
                  }}
                />
              ) : (
                <></>
              )}
            </Grid>
          );
        })}
      </Grid>
    </Stack>
  );
};

export default CostDetailSection;
